import {Component} from 'nuxt-property-decorator';
import Vue, {CreateElement} from 'vue';
import {commonService} from '~/lib/accessors/api';
import Page from '~/components/Page.vue';
import PageSection from '~/components/PageSection.vue';
import Html from '../util/Html.vue';

@Component
export default class PageFromBackendComponent extends Vue {
  content = ''

  static async AsyncData(path: string) {
    const pageHtml = await commonService
      .withErrorBroker()
      .getPageByPath(path);

    return {
      content: pageHtml.content,
    }
  }

  render(h: CreateElement) {
    return <Page>
      <PageSection>
        <div class="underline-links">
          <Html html={this.content}/>
        </div>
      </PageSection>
    </Page>;
  }
}
